/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { env } from '$env/dynamic/public';

export function getWebsocketUrl():string {
    if (env.PUBLIC_NODE_ENV === 'dev') {
        return `ws://${env.PUBLIC_DOMAIN_WSS}`
    } else {
        return `wss://${env.PUBLIC_DOMAIN_WSS}/conversational/garden-webchat-api`
    }
}